import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { successAlert } from "../../../style/scss/utils/Alerts";
import { forgotPassword, updatePassword } from "../../../apis/financers";
import { useSearchParams } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

const ForgotPassword = () => {
  const navigation = useNavigate();
  const [email, setEmail] = useState("");
  const [searchParams] = useSearchParams();
  const reset = searchParams.get("reset");
  const email_ = searchParams.get("email");
  const userName = searchParams.get("username");
  const token = searchParams.get("token");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const navigationPath = async (e) => {
    e.preventDefault();
    try {
      await forgotPassword({ username: email });
      successAlert("Success", "Reset password link sent to given email.");
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdatePass = async (e) => {
    e.preventDefault();
    try {
      const userDetails = JSON.parse(sessionStorage.getItem("info")) || {};
      await updatePassword({
        user_id: userDetails.user_id,
        new_password: newPass,
        email: email_,
        username: userName
      });
      successAlert("Success", "Password is successfully reset.");
      navigation('/login')
    } catch (err) {
      return err;
    }
  };

  if (token) {
    const decoded = jwtDecode(token);

    const now = Math.floor(Date.now() / 1000);
    if (decoded.exp < now) {
      alert("Link expired");
      return;
    }
  }

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-5">
            <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
              <div className="bg-overlay-img">
                <ImageWithBasePath
                  src="assets/img/bg/bg-01.png"
                  className="bg-1"
                  alt="Img"
                />
                <ImageWithBasePath
                  src="assets/img/bg/bg-02.png"
                  className="bg-2"
                  alt="Img"
                />
                <ImageWithBasePath
                  src="assets/img/bg/bg-03.png"
                  className="bg-3"
                  alt="Img"
                />
              </div>
              <div className="authentication-card w-100">
                <div className="authen-overlay-item border w-100">
                  <h1 className="text-white display-1">
                    Fueling Retail Growth with Smart NSSOFT TECH Finance Solutions
                  </h1>
                  <div className="my-4 mx-auto authen-overlay-img">
                    <ImageWithBasePath
                      src="assets/img/bg/authentication-bg-01.png"
                      alt="Img"
                    />
                  </div>
                  <div>
                    <p className="text-white fs-20 fw-semibold text-center">
                      Efficiently manage your workforce, streamline <br />{" "}
                      operations effortlessly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
              <div className="col-md-7 mx-auto vh-100">
                <form className="vh-100">
                  <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                    <div className=" mx-auto mb-5 text-center">
                      <ImageWithBasePath
                        src="assets/logo1.png"
                        className="img-fluid"
                        alt="Logo"
                        width={100}
                        height={100}
                      />
                    </div>
                    {reset === "true" ? (
                      <div>
                        <div className="mb-3">
                          <label className="form-label">New Password</label>
                          <div className="input-group">
                            <input
                              type="text"
                              defaultValue=""
                              className="form-control border-end-0"
                              onChange={(e) => setNewPass(e.target.value)}
                            />
                            <span className="input-group-text border-start-0">
                              <i className="ti ti-mail" />
                            </span>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Confirm Password</label>
                          <div className="input-group">
                            <input
                              type="text"
                              defaultValue=""
                              className="form-control border-end-0"
                              onChange={(e) => setConfirmPass(e.target.value)}
                            />
                            <span className="input-group-text border-start-0">
                              <i className="ti ti-mail" />
                            </span>
                          </div>
                        </div>
                        <div className="mb-3">
                          <button
                            type="submit"
                            onClick={handleUpdatePass}
                            className="btn btn-primary w-100"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="">
                        <div className="text-center mb-3">
                          <h2 className="mb-2">Forgot Password?</h2>
                          <p className="mb-0">
                            If you forgot your password, well, then we'll email
                            you instructions to reset your password.
                          </p>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">UserName</label>
                          <div className="input-group">
                            <input
                              type="text"
                              defaultValue=""
                              className="form-control border-end-0"
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            <span className="input-group-text border-start-0">
                              <i className="ti ti-mail" />
                            </span>
                          </div>
                        </div>
                        <div className="mb-3">
                          <button
                            type="submit"
                            onClick={navigationPath}
                            className="btn btn-primary w-100"
                          >
                            Submit
                          </button>
                        </div>
                        <div className="text-center">
                          <h6 className="fw-normal text-dark mb-0">
                            Return to
                            <Link
                              to={all_routes.login}
                              className="hover-a ms-1"
                            >
                              Sign In
                            </Link>
                          </h6>
                        </div>
                      </div>
                    )}
                    <div className="mt-5 pb-4 text-center">
                      {/* <p className="mb-0 text-gray-9">
                        Copyright © 2024 - Smarthr
                      </p> */}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
